var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content error-page row no-gutters justify-center mt-4"},[_c('div',{staticClass:"col-xs-12 align-center justify-center row no-gutters text-center"},[_c('v-alert',{attrs:{"outlined":"","type":"warning","prominent":"","border":"left"}},[_vm._v("Oooops~找不到頁面")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }